import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
  selector: 'score',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './score.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScoreComponent {
  score = input.required<number | null>()

  get scoreDots(): number[] {
    return [0, 1, 2]
  }

  scoreLevel(): number {
    const score = this.score()
    if (score === null) return 0

    if (score <= 31) return 1
    if (score <= 79) return 2
    return 3
  }

  scoreColor(): 'red' | 'yellow' | 'green' {
    const score = this.score()
    if (score === null) return 'red'

    if (score <= 31) return 'red'
    if (score <= 79) return 'yellow'
    if (score > 79) return 'green'
    return 'red'
  }

  getGradientColor(index: number): Record<string, boolean> {
    if (index < this.scoreLevel()) {
      switch (this.scoreColor()) {
        case 'green':
          return {
            'bg-gradient-to-b': true,
            'from-[#00B575]': true,
            'to-[#006D47]': true
          }
        case 'yellow':
          return {
            'bg-gradient-to-b': true,
            'from-[#FFBB38]': true,
            'to-[#D88E00]': true
          }
        case 'red':
          return {
            'bg-gradient-to-b': true,
            'from-[#B52D2D]': true,
            'to-[#8C2323]': true
          }
      }
    }

    return {
      'bg-gray-slate': true
    }
  }
}
